import type { AdminModerationReview, ReviewReportRecord } from "@/types/api";
import ReportedReviewsTable from "./ReportedReviewsTable";

interface ReviewManagementTabsProps {
  activeTab: string;
  setActiveTab: (value: string) => void;
  reviewsReports: ReviewReportRecord[];
  reportedReviews: AdminModerationReview[];
  onResolveReport: (reportId: string) => void;
  onVisibilityToggle: (reviewId: string, newVisibility: boolean) => Promise<void>;
  onDeleteReview: (reviewId: string) => void;
  isProcessing: boolean;
}

const ReviewManagementTabs = ({
  activeTab,
  setActiveTab,
  reviewsReports,
  reportedReviews,
  onResolveReport,
  onVisibilityToggle,
  onDeleteReview,
  isProcessing
}: ReviewManagementTabsProps) => {
  return (
    <>
      <ReportedReviewsTable 
        reports={reviewsReports}
        reviews={reportedReviews}
        onResolveReport={onResolveReport}
        onVisibilityToggle={onVisibilityToggle}
        onDeleteReview={onDeleteReview}
        isProcessing={isProcessing}
      />
    </>
  );
};

export default ReviewManagementTabs;
